// PLK does not use gift cards
export default () => null;
